import SkeletonScreen from './SkeletonScreen.vue'

export default {
    install (Vue) {
        Vue.component('SkeletonScreen', SkeletonScreen)
    }
}